const ES = {
  acceptRequest: "Aceptar la solicitud",
  accessDetail: "Detalle de acceso",
  accessoryUnavailable: "Accesorio(s) no disponible(s)",
  actions: "Acciones",
  activity: "Actividad",
  add: "Agregar",
  addAgency: "Añadir agencia",
  addAgencyInfoBullet1: "Solicitar presupuestos y realizar pedidos directamente.",
  addAgencyInfoBullet2: "Beneficiarse de los precios de sus contratos marco existentes.",
  addAgencyInfoBullet3: "Acceder a los recursos que les asigne.",
  addAgencyInfoTitle: "Al añadir esta agencia, sus clientes podrán:",
  addDocuments: "Agregar documentos",
  addEvent: "Agregar evento",
  addFile: "Agregar archivo",
  addInformation: "Agregar información",
  additionalInformation: "Información adicional",
  addMessageToCustomer: "Mensaje para el cliente",
  addNewDocument: "Agregar nuevo documento",
  addParticipant: "Añadir participante",
  addResource: "Agregar un recurso",
  address: "Dirección",
  addUser: "Agregar usuario",
  agencies: "Agencias",
  agency: "Agencia",
  agencyArchived: "Agencia archivada",
  agencyCreated: "Agencia creada",
  agencyEmailDescription:
    "Todas las notificaciones de los pedidos de la agencia (solicitud de presupuesto, inicio de alquiler, evento, devolución, etc.) se enviarán a los usuarios de la agencia, así como a esta dirección de correo electrónico.",
  agencyIsRequired: "Agencia obligatoria",
  agencyName: "Nombre de la agencia",
  agencyUpdated: "Agencia actualizada",
  allFilesUpToDate: "Todos los archivos están actualizados",
  allMyOrders: "Todos mis pedidos",
  allResources: "Todos los recursos",
  alreadyCustomer: "¿Ya es cliente?",
  analytics: "Analítica",
  anErrorOccurred: "Ocurrió un error",
  apiStatus: "Estado de la API",
  applicant: "Solicitante",
  applicationVersion: "Versión de la aplicación",
  archive: "Archivar",
  archive_one: "{{count}} Archivo",
  archive_other: "{{count}} Archivos",
  archiveAgency: "Archivar agencia",
  archiveAgencyConfirmation:
    "¿Está seguro de que desea archivar la agencia {{name}}? Todos los contratos relacionados se archivarán y las solicitudes de reserva pendientes se cancelarán.",
  archived: "Archivada",
  areYouAConstructionCompany: "¿Es una empresa de construcción?",
  areYouSureYouWantDetachResource: "¿Está seguro de que desea desvincular el recurso de este pedido?",
  areYouSureYouWantDetachUser:
    "¿Está seguro de que desea desvincular a este usuario de la agencia? Este usuario será notificado por correo electrónico.",
  areYouSureYouWantToDelete: "¿Está seguro de que desea eliminar?",
  areYouSureYouWantToDeleteWithItem: "¿Está seguro de que desea eliminar {{item}}?",
  article: "Artículo",
  articleAccess: "Acceso al artículo",
  articleCategory: "Categoría",
  articleEquipmentUpdated: "Equipo del artículo actualizado",
  articleInformation: {
    message: "Elija una máquina de su flota interna o un operador",
    warningDescription:
      "Falta información del equipo. Proporcione los documentos e información requeridos antes de que comience el alquiler.",
    warningTitle: "Falta información del equipo",
  },
  articleNameIsRequired: "El nombre del artículo es obligatorio",
  articles: "Artículos",
  assignment: "Asignación",
  associatedMachine: "Máquina asociada",
  attachAResource: "Seleccionar un recurso",
  attachResource: "Vincular un recurso",
  availability: "Disponibilidad",
  available: "Disponible",
  backToLogin: "Volver al inicio de sesión",
  beginning: "Inicio",
  between: "entre",
  billing: "Facturación",
  billingDetailsAssociatedWithThisOrder: "Detalles de facturación asociados a este pedido",
  billings: "Facturaciones",
  booking: {
    addAnItem: "Agregar un artículo",
    automaticExtension: "Extensión automática",
    bankingHolidays: "Días festivos",
    date: "Desde la fecha",
    day: "Día",
    days: "Días",
    fromDate: "Desde la fecha",
    saturday: "Sábado",
    sunday: "Domingo",
    toDate: "Hasta",
    useOn: "Usar en:",
  },
  bookingDate: "{{fromDate}} a {{toDate}}",
  bookingEnd: "Fin de la reserva",
  bookingStart: "Inicio de la reserva",
  bookingStartTomorrow: "La reserva comienza mañana",
  bookingStartTomorrowMessage:
    "Asegúrese de que todo esté listo para la entrega, respetando las restricciones del cliente e incluyendo los accesorios solicitados si corresponde.",
  bookings: "Reservas",
  brand: "Marca",
  brandIsRequired: "La marca es obligatoria",
  breadcrumbs: {
    booking: {
      requests: "n°{{id}}",
    },
  },
  by: "por",
  byFile: "por archivo",
  cancel: "Cancelar",
  canceled: "Cancelado",
  category: "Categoría",
  categoryName: "Nombre de la categoría",
  ceCertificate: "Certificado CE",
  changePasswordAccount: "Cambiar la contraseña de su cuenta Tracktor",
  chat: "Chatear",
  clickToUpload: "Haga clic para cargar",
  client: "Cliente",
  clientRequest: "Solicitud del cliente",
  clients: "Clientes",
  clientWillBeNotifiedByEmail: "El usuario invitado será notificado por correo electrónico.",
  close: "Cerrar",
  closed: "Cerrado",
  closedAt: "Cerrado el {{date}}",
  closedAtIncidentAlert: "Cerrado el {{date}} por {{by}}",
  closeTheIncident: "Cerrar el incidente",
  code: "Código",
  codeOrKeysLocation: "Código o ubicación de las llaves",
  commandPosts: "Puestos de mando",
  company: "Empresa",
  completed: "Completado",
  confirm: "Confirmar",
  confirmed: "Confirmado",
  contactAction: "Contactar",
  contacts: "Contactos",
  continue: "Continuar",
  couldNotFindBookingItem: "No se pudo encontrar el artículo de la reserva",
  countryCode: "Código de país",
  createAPasswordForYourAccount: "Cree una contraseña para su cuenta",
  createNewResource: "Crear un nuevo recurso",
  createNewUser: "Crear nuevo usuario",
  createYourFirstConversation: "Crea tu primera conversación",
  currentApiVersion: "Versión actual de la API",
  currentApiVersionUsed: "Versión de la API utilizada",
  darkMode: "Modo oscuro",
  darkTheme: "Tema oscuro",
  dashboard: "Panel",
  dataSheet: "Ficha técnica",
  date: {
    endDate: "Fecha de finalización",
    startDate: "Fecha de inicio",
  },
  dates: "Fechas",
  dayCount_one: "{{count}} Día",
  dayCount_other: "{{count}} Días",
  deals: "Ofertas",
  dealsView: {
    detailed: "Detallado",
    grouped: "Agrupado",
    kanban: "Kanban",
    list: "Lista",
    planning: "Planificación",
  },
  delete: "Eliminar",
  deleteBookingFileMessage: "¿Está seguro de que desea eliminar este archivo de la reserva?",
  deleteConversation: "Eliminar conversación",
  deleteFile: "Eliminar archivo",
  deleteFileConfirmation: "La eliminación del archivo es irreversible. ¿Está seguro de que desea continuar?",
  deleteResource: "Eliminar recurso",
  deleteResourceConfirmation:
    "La eliminación de un recurso es irreversible y eliminará todos los archivos asociados. ¿Está seguro de que desea continuar?",
  delivery: "Entrega",
  deliveryAndReturn: "Entrega y Devolución",
  deliveryTimeConstraint: "Restricción de horario de entrega",
  designation: "Designación",
  detach: "Desvincular",
  detachResource: "Desvincular recurso",
  detachUser: "Desvincular usuario",
  detachUserSuccessfully: "Usuario desvinculado con éxito",
  document: "documento",
  documentAdded: "Documento agregado",
  documentDeleted: "Documento eliminado",
  documentExp: "Doc. cad.",
  documentIssue_one: "{{count}} doc pendiente",
  documentIssue_other: "{{count}} docs pendientes",
  documentIssueTooltip_one: "{{count}} documento faltante o caducado",
  documentIssueTooltip_other: "{{count}} documentos faltantes o caducados",
  documentMissing_one: "{{count}} doc faltante",
  documentMissing_other: "{{count}} docs faltantes",
  documentName: "Nombre del documento",
  documents: "Documentos",
  documentsOk: "Docs OK",
  documentType: "Tipo de documento",
  documentUpdated: "Documento actualizado",
  edit: "Editar",
  editInfoDocument: "Editar información del documento",
  editMyPassword: "Editar mi contraseña",
  editResource: "Editar recurso",
  editUser: "Editar usuario",
  email: "Correo electrónico",
  emailSent: "Correo enviado",
  emailSentForgotPassword: "Se ha enviado un correo para restablecer su contraseña.",
  emptyBooking: "No tiene reservas próximas",
  emptyBookingMissing: "No tiene solicitudes perdidas",
  emptyState: {
    noDealsFound: "Aún no tiene ningún pedido.",
    noDealsFoundDescription: "Sus nuevos pedidos aparecerán en esta tabla.",
    pageNotFoundDescription: "La página que busca no se encuentra. Por favor, verifique la URL o regrese a la página anterior.",
    returnToOrders: "Volver a los pedidos",
  },
  end: "Fin",
  enterTheCode: "Introduzca el código",
  enterToSend: "↵ Enter para enviar · ⇧ Shift+↵ Enter para nueva línea",
  enterYourCode: "Introduzca su código",
  enterYourMessage: "Introduzca su mensaje",
  entity: "Entidad",
  equipment: "Equipo",
  equipmentInformation: {
    maximumPlates: "Carga máxima en el patín (T)",
    sizePlates: "Tamaño de las placas de distribución (m²)",
    skid: "Presión máxima bajo la placa de distribución (T/m²)",
  },
  equipmentNotOffered: "Equipo no ofrecido",
  error: {
    missingArticle: "Artículo faltante",
    missingDates: "Faltan fechas",
    missingQuantity: "Falta cantidad",
    missingUnitPrice: "Falta el precio unitario",
    noBookingFound: "No se encontró ninguna reserva",
    noClientFoundForThisRequest: "No se encontró ningún cliente para esta solicitud",
    pleaseFillFields: "Por favor, complete todos los campos obligatorios",
    pleaseSelectArticleBeforeAddingNewOne: "Por favor, seleccione un artículo antes de agregar uno nuevo",
    positiveValueOnly: "Solo se permiten valores positivos",
    resourceMustBeSelected: "Debe seleccionar un recurso",
    selectDates: "Por favor, seleccione las fechas de reserva",
    shouldBeANumber: "Debe ser un número",
    someRequestDataAreMissing: "Faltan algunos datos de la solicitud",
    unknownError: "Error desconocido, inténtelo de nuevo",
  },
  error404: "Error 404",
  errorLoadingRequests: "Ocurrió un error al cargar las solicitudes",
  escape: "Escapar",
  eventStatus: {
    accepted: "Solicitud de alquiler aceptada",
    canceled: "Solicitud de alquiler cancelada",
    refused: "Solicitud de alquiler rechazada",
    sent: "Solicitud de alquiler recibida",
  },
  eventUpdated: "Evento actualizado",
  expirationDate: "Fecha de vencimiento",
  expired: "Vencido",
  file: "el documento",
  fileAddedSuccessfully: "Archivo agregado con éxito",
  fileArchivedSuccessfully: "Archivo archivado con éxito",
  fileDeletedSuccessfully: "Archivo eliminado con éxito",
  fileHasBeenUploaded: "El archivo ha sido cargado",
  fileName: "Nombre del archivo",
  fileStatus: {
    expired: "Vencido",
    expires_soon: "Vence pronto",
    up_to_date: "Actualizado",
  },
  files: "Archivos",
  filesNotUpToDate: "Algunos archivos no están actualizados",
  fileType: "Tipo de archivo",
  fileUnarchivedSuccessfully: "Archivo desarchivado con éxito",
  finish: "Finalizar",
  finishDayCount: "Este término termina en {{count}} días",
  finishToday: "Termina hoy",
  finishTomorrow: "Termina mañana",
  firstName: "Nombre",
  flatRate: "Tarifa fija",
  fleetNumber: "Número de parque",
  forgottenPassword: "Contraseña olvidada",
  forgottenPasswordSubtitle: "Introduzca su correo electrónico. Le enviaremos un enlace para restablecer su contraseña",
  form: {
    constraint: {
      password: "La contraseña debe contener al menos 8 caracteres y una letra mayúscula",
    },
    validation: {
      required: "Este campo es obligatorio",
    },
  },
  generalTerms: "Términos generales",
  getSupport: "Obtener soporte",
  giveFeedback: "Dar retroalimentación",
  globalSearchPlaceholder: "Introduzca un ID de oferta o nombre de artículo",
  happyToSeeYouAgain: "¡Feliz de verte de nuevo!",
  help: "Ayuda",
  helperText: {
    onlyImageFilesAreAllowed: "Solo se permiten archivos .png, .jpeg, .pdf",
  },
  history: "Historial",
  home: "Inicio",
  icon: "Icono",
  identity: "Identidad",
  identityCard: "Documento de identidad",
  import: "Importar",
  importFile: "Importar archivo",
  incidentAddedSuccessfully: "Incidente agregado con éxito",
  incidentClosed: "Incidente cerrado",
  incidentOpened: "Incidente abierto",
  indicateCodeOrKeysLocation: "Indique el código o la ubicación de las llaves",
  information: "Información",
  informations: "Informaciones",
  inProgress: "En curso",
  instructionManual: "Manual de instrucciones",
  insurance: "Seguro",
  internalCode: "Código interno",
  internalCodeIsRequired: "El código interno es obligatorio",
  invoice: "Factura",
  irreversibleAction: "Esta acción es irreversible",
  key: "Llave",
  keyLocation: "Ubicación de la llave",
  keys: "Llaves",
  language: "Idioma",
  lastName: "Apellido",
  linkDocuments: "Vincular documentos",
  linkDocumentsToBooking: "Documentos visibles para el cliente",
  list: "Lista",
  logIn: "Inicie sesión",
  login: "Iniciar sesión",
  logout: "Cerrar sesión",
  machine: "Máquina",
  machineRegistration: "Registro de la máquina",
  mail: "Correo",
  maintenanceLog: "Registro de mantenimiento",
  makeAnOffer: "Hacer una oferta",
  material: "Material",
  materialDropOffPoint: "Punto de entrega del material",
  messagePlaceholder: "Carga máxima en patín (T), dimensiones de las placas de reparto (m²)…",
  messages: "Mensajes",
  messageToCustomer: "Mensaje para el cliente",
  missed: "Perdido",
  missingRole: "Falta rol",
  modifyMyOffer: "Modificar mi oferta",
  modifyOffer: "Modificar oferta",
  myProfile: "Mi perfil",
  name: "Nombre",
  newConversation: "Nueva conversación",
  newDate: "Nueva fecha",
  newDateProposal: "Disponible a partir de otra fecha próxima",
  newDocument: "Nuevo documento",
  newMessage: "Nuevo mensaje",
  newMessageCount_one: "{{count}} mensaje nuevo",
  newMessageCount_other: "{{count}} mensajes nuevos",
  newPassword: "Nueva contraseña",
  newPasswordConfirm: "Confirmar nueva contraseña",
  newResourceCreated: "¡Su nuevo recurso ha sido creado!",
  newResourceCreatedDetails: "Cargue documentos y sus fechas de validez.",
  next: "Siguiente",
  nextAssignment: "Próxima asignación",
  no: "No",
  noAgenciesFound: "No se encontraron agencias",
  noAvailability: "Sin disponibilidad y degradación imposible",
  noDocumentsFound: "No se encontraron documentos",
  noEvents: "No hay eventos",
  noFilesAttached: "No hay archivos adjuntos",
  noNameFound: "No se encontró nombre",
  noOrderFound: "No se encontró ningún pedido asociado a este artículo",
  notAvailable: "No disponible",
  notes: "Notas",
  notFound: "La página que busca no se ha encontrado.",
  notFoundRedirection: "Verifique la URL o vuelva a la página anterior.",
  noUsersFound: "No se encontraron usuarios",
  num: "N°",
  numberOfDays: "Número de días",
  numberParc: "N° de parque",
  numberParcShort: "N° parque",
  offerSendTo: "Su oferta ha sido enviada a {{name}}",
  offerSendToDetails: "Se le notificará tan pronto como su cliente apruebe su oferta.",
  onboarding: {
    featureRequests: {
      step1Description:
        "Los clientes ven inmediatamente en Tracktor los proveedores más cercanos a su obra, ordenados por distancia y precios de contrato marco.",
      step1Title: "Aumenta tus ingresos",
      step2Description:
        "Complete su presupuesto y envíelo. Al responder rápidamente con un precio competitivo, aumenta sus posibilidades de ser seleccionado por el cliente.",
      step2Title: "Respondan en solo unos clics",
    },
  },
  open: "Abierto",
  openFullPage: "Abrir en página completa",
  openFullScreen: "Abrir en pantalla completa",
  operator: "Operador",
  operatorDocExp: "Oper. exp.",
  operatorDocKo: "Oper. KO",
  operatorDocMissing_one: "{{count}} oper. faltante",
  operatorDocMissing_other: "{{count}} oper. faltantes",
  operatorDocument: "Documento del operador",
  order: "Pedido",
  orderHistory: "Historial de pedidos",
  orderSummary: "Resumen del pedido",
  orders: "Pedidos",
  other: "Otro",
  oups: "¡Ups!",
  overview: "Resumen",
  pageNotFound: "Página no encontrada",
  participants: "Participantes",
  password: "Contraseña",
  passwordSetSuccessfully: "Su contraseña ha sido actualizada",
  passwordsNotMatching: "Las contraseñas no coinciden",
  passwordUpdated: "Su contraseña ha sido actualizada",
  payments: "Pagos",
  periodicGeneralInspection: "Inspección general periódica (PGI)",
  phone: "Teléfono",
  phoneNumber: "Número de teléfono",
  planning: "Planificación",
  pleaseSetAPassword: "Por favor, defina una contraseña",
  price: "Precio",
  priceExVAT: "Sin IVA",
  profile: "Mi perfil",
  profileUpdated: "Su perfil ha sido actualizado",
  purchaseOrder: "Orden de compra",
  purchaseOrderNumber: "Número de orden de compra",
  quantity: "Cantidad",
  quote: "Presupuesto",
  reason: "Motivo",
  received: "Recibido",
  refuse: "Rechazar",
  refused: "Rechazado",
  refusedBookingRequestMessage: "Al confirmar el rechazo de esta solicitud de reserva, no podrá aceptarla posteriormente.",
  refusedTheBooking: "Pedido rechazado",
  refuseRequest: "Rechazar la solicitud",
  releaseNotRequested: "El cliente aún no ha solicitado la liberación",
  releaseRequestedForDate: "Liberación solicitada para el {{date}}",
  reload: "Recargar",
  rentalRequests: "Solicitudes",
  reopenTheIncident: "Reabrir el incidente",
  replace: "Reemplazar",
  request: "Solicitud",
  requestMissedAlert: {
    button: "Volver a mis solicitudes",
    description1: "El cliente envió esta solicitud a varios proveedores y aceptó una de sus ofertas.",
    description2:
      "En Tracktor, los proveedores responden en promedio en menos de una hora: sé rápido para maximizar tus oportunidades futuras.",
    redirection: "👉 Aprende más sobre la búsqueda de proveedores en Tracktor",
    title: "Solicitudes perdidas",
  },
  requestOfferAlertInfoDescription:
    "Responder a cada solicitud (incluso con una negativa) aumenta en un 65% sus posibilidades de ser contactado nuevamente por este cliente.",
  requestOfferAlertInfoTitle: "No pierda ninguna oportunidad",
  requestStatus: {
    expired: "Vencido",
    proposed: "Propuesto",
    refused: "Rechazado",
    toTreat: "Por tratar",
  },
  requests: "Solicitudes",

  requestWithID: "Solicitudes n°{{id}}",
  required: "Obligatorio",
  reservation: "Reserva",
  reservationRequestAccepted: "Solicitud de reserva aceptada, se ha creado el pedido",
  reservationRequestInfo:
    "Al aceptar, esta solicitud se transformará automáticamente en un pedido con las condiciones indicadas arriba. Aparecerá en sus Pedidos y el cliente será informado.",
  resetInitialRequest: "Restablecer solicitud inicial",
  resetPassword: "Restablecer contraseña",
  resource: "Recurso",
  resourceAddedSuccessfully: "Recurso agregado con éxito",
  resourceCreated: "Recursos creados",
  resourceDetachedSuccessfully: "Recurso desvinculado con éxito",
  resourceEmptyState: {
    button: "Agregue su primer recurso",
    dialogContentText: "Agregue varios recursos a la vez importando un archivo (CSV, XLS, XLSX, PDF...) o agréguelos manualmente.",
    dialogPrimaryButton: "Agregar manualmente",
    dialogSecondaryButton: "Importar un archivo",
    dialogSuccessContentText:
      "El procesamiento de sus recursos está en curso. Pronto estarán disponibles en su espacio y se le notificará por correo electrónico.",
    dialogSuccessTitle: "Recursos transferidos",
    dialogTitle: "Elija su método",
    listSubtitle1: "Agregue un nuevo recurso a su espacio",
    listSubtitle2: "Y especifique las fechas de validez",
    listSubtitle3: "Todos los documentos serán enviados al cliente",
    listTitle1: "Guardar un recurso",
    listTitle2: "Agregar documentos",
    listTitle3: "Asignarlo a un pedido",
    title: "Agregue su primer recurso y simplifique la gestión de sus pedidos",
  },
  resourceName: "Nombre del recurso",
  resourcePhoto: "Foto de los recursos",
  resourcePhotoHelperText: "PNG o JPG (máx. 5 MB)",
  resourceSearchPlaceholder: "Escriba para buscar (modelo, número de flota)",
  resources: "Recursos",
  resourceUpdated: "Recursos actualizados",
  resourceUpdatedSuccessfully: "Recurso actualizado con éxito",
  respondToDemand: "Responder a la solicitud",
  return: "Devolución",
  returnTo: "Volver a",
  role: "Rol",
  save: "Guardar",
  saveChanges: "Guardar cambios",
  search: "Buscar",
  searchContacts: "Buscar contactos",
  searchInApp: "Buscar en la app",
  see: "Ver",
  seeDetail: "Ver detalle",
  seeOffer: "Ver oferta",
  seeTheLines: "Ver las líneas",
  seeTheResource: "Ver el recurso",
  selectAnAgency: "Seleccione una agencia",
  selectAnAgencyToAttachCategory: "Seleccione una agencia para adjuntar esta categoría",
  selectAnotherResource: "Seleccionar otro recurso",
  selectDocumentType: "Seleccione el tipo de documento",
  selectExpirationDate: "Seleccione la fecha de vencimiento",
  selectResource: "Seleccione el recurso",
  selectResourceWarning:
    "Al seleccionar este recurso, confirma que cumple con las necesidades del cliente. Su cliente será notificado por correo electrónico.",
  send: "Enviar",
  sendOffer: "Enviar oferta",
  sent: "Enviado",
  serialNumber: "Número de serie",
  service: "Servicio",
  settings: "Parámetros",
  siret: "SIRET / Número DNS",
  siretMustBe14Characters: "El SIRET debe tener exactamente 14 caracteres",
  sorenAnnouncement: {
    badge: "Pronto Soren",
    badgeSwitched: "Ahora Soren",
    badgeSwitchedTooltip: "Tracktor ahora es Soren — saber más",
    badgeTooltip: "Tracktor se convierte en Soren — saber más",
    gotIt: "Entendido",
    readArticle: "Leer el anuncio",
    story: {
      goToCard: "Tarjeta {{count}}",
      nextCard: "Tarjeta siguiente",
      previousCard: "Tarjeta anterior",
      switchTitle: "Tracktor cambia de nombre de aquí al {{date}}.",
      switchTitlePast: "Tracktor cambió de nombre el {{date}}.",
      switchTitleToday: "Tracktor cambia de nombre hoy.",
      thanksBody: "Por tus máquinas, tus equipos y tu confianza.",
      thanksBodyOrders_one: "{{number}} pedido juntos. Por tus máquinas, tus equipos y tu confianza.",
      thanksBodyOrders_other: "{{number}} pedidos juntos. Por tus máquinas, tus equipos y tu confianza.",
      thanksTitle: "Gracias, {{name}}.",
      thanksTitleAnonymous: "Gracias.",
    },
    unchanged: {
      accessTitle: "Mismos accesos",
      contactsTitle: "Mismos interlocutores",
      ordersTitle: "Mismos pedidos y clientes",
      title: "Nada cambia salvo el nombre y el logo.",
    },
  },
  startDayCount: "Comienza en {{count}} días",
  startToday: "Comienza hoy",
  startTomorrow: "Comienza mañana",
  status: "Estado",
  supplier: "Proveedor",
  supplierComment: "Comentario del proveedor",
  TECHNICAL_SHEET: "Ficha técnica",
  theBookingRequestHasBeenAccepted: "Su oferta ha sido enviada",
  theBookingRequestHasBeenRefused: "La solicitud de reserva ha sido rechazada",
  to: "Para",
  to_add: "Por agregar",
  toAdd: "Por agregar",
  toCome: "Por venir",
  toDo: "Por hacer",
  today: "Hoy",
  tokenVerification: "Verificación de token",
  total: "Total",
  totalHT: "Total sin IVA",
  toUpdate: "Por actualizar",
  type: "Tipo",
  typeToSearch: "Escriba para buscar",
  unarchive: "Desarchivar",
  units: {
    DAYS_one: "{{count}} Día",
    DAYS_other: "{{count}} Días",
    HOURS_one: "{{count}} Hora",
    HOURS_other: "{{count}} Horas",
    KM: "{{count}} Km",
    null: "{{count}} ",
    unit: "Unidad",
    units: "Unidades",
    units_one: "{{count}} Unidad",
    units_other: "{{count}} Unidades",
  },
  up_to_date: "Actualizado",
  uploadFile: "Cargar archivo",
  upToDate: "Actualizado",
  userHasBeenAttachedToAgency: "El usuario ha sido adjuntado a la agencia",
  users: "Usuarios",
  usersActions: {
    archiveUser: "Archivar usuario",
    archiveUserSuccessfully: "Usuario archivado con éxito",
    areYouSureYouWantToArchiveThisUser:
      "¿Estás seguro de que quieres archivar a este usuario? Este usuario ya no tendrá acceso al espacio de la agencia y será notificado por correo electrónico.",
    unarchiveUser: "Desarchivar usuario",
    unarchiveUserDescription:
      "Al desarchivar a este usuario, recuperará el acceso al espacio de la agencia y será notificado por correo electrónico.",
    unarchiveUserSuccessfully: "Usuario desarchivado con éxito",
    userCreatedSuccessfully: "Usuario creado con éxito",
    userUpdatedSuccessfully: "Usuario actualizado con éxito",
  },
  userUnarchivedSuccessfully: "Usuario desarchivado con éxito",
  validate: "Validar",
  worksiteAccessConstraints: "Restricciones de acceso a la obra",
  writeAMessage: "Escribe un mensaje...",
  yes: "Sí",
  yesterday: "Ayer",
  yourAccount: "Su cuenta",
  yourClientWillBeNotifiedByEmail: "Su cliente será notificado por correo electrónico.",
  yourOffer: "Su oferta",
  yourOrdersAreWaitingForYouLogin: "¡Sus pedidos le esperan, inicie sesión!",
  yourResourcesWillBeAddedToYourSpaceAfterProcessing: "Sus recursos se agregarán a su espacio después del procesamiento",
} as const;

export default ES;
